export class HistorieRequest {
    public username: string;
    public password: string;
    public abLfDatum: string;
    public abBestDatum: string;
}

export class HistorieResponse {
    public success = false;
    public errorText: string;
    public zeilen: HistoriePos[] = [];
}

export class HistoriePos {
    public shop: string;
    public status: number;
    public bestelldatum: string;
    public lieferdatum: string;
    public kondition: string;
    public artikelBezeichnung: string;
    public artikelZusatz: string;
    public topf: string;
    public topfInCm: string;
    public hoehe: string;
    public hoeheInCm: string;
    public vpe: number;
    public ehplg: number;
    public lgpcc: number;
    public anzahlVkEh: number;
    public anzahlVkLg: number;
    public anzahlVkCc: number;
    public anzahlVkStk: number;
    public istPreis: number;
    public bestellhinweis: string;
    public absagegrund: string;
    public ean: string;
}
